// SupportCtaSection.js
import React from 'react';
import { Play } from 'lucide-react';
import supportImage from '../assets/how-respite-care-works-image.jpg';

const SupportCtaSection = () => {
  return (
    <section className="bg-white py-12 md:py-16">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        {/* Image with decorative play marker */}
        <div className="relative rounded-2xl overflow-hidden">
          <img
            src={supportImage}
            alt="A carer walking alongside an older person in a bright hallway"
            className="w-full h-[320px] md:h-[460px] object-cover"
          />
          <div className="absolute inset-0 flex items-center justify-center">
            <span className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-primary/90 text-white shadow-lg">
              <Play size={24} fill="currentColor" />
            </span>
          </div>
        </div>

        {/* Heading + phone */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 items-center mt-12">
          <h2 className="font-display font-light text-ink leading-[1.1] text-3xl md:text-4xl lg:text-5xl">
            We’re here when<br className="hidden md:block" /> you need us.
          </h2>
          <div className="md:text-right">
            <p className="text-muted text-sm md:text-base mb-3">
              Need support, have questions, or want to connect?
            </p>
            <a
              href="tel:+61480804640"
              className="inline-block border-2 border-primary text-primary hover:bg-primary hover:text-white font-medium text-lg md:text-xl px-7 py-3 rounded-full transition-colors"
            >
              +61 420 162 243
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SupportCtaSection;
